module.exports = __webpack_public_path__ + "img/expedited-blue.6163d3a9.svg";